import React from 'react';

import { useDocuments } from '~/react-query-hooks/documents/useDocumentsEntity';

import { useDocumentModal } from '../../document-modal/useDocumentModal';
import * as S from './DocumentsRowStyles';

export interface DocumentsRowProps {
  id: string;
  name: string;
}

export const DocumentsRow = ({ id, name }: DocumentsRowProps) => {
  const { openModal } = useDocumentModal();
  const { data, isFetching } = useDocuments([id]);

  const document = data?.[0];

  const getContent = () => {
    if (isFetching) {
      return <S.StyledSkeletonLoader />;
    } else if (document) {
      return (
        <S.RowWrapper>
          <S.PdfIcon src="/app/static/images/icons/pdf.svg" />
          <S.FlexColumn>
            <S.TitleLabel>{`${name || document.name}.${
              document.type
            }`}</S.TitleLabel>
          </S.FlexColumn>
        </S.RowWrapper>
      );
    } else {
      return null;
    }
  };

  return <S.Root onClick={() => openModal(id)}>{getContent()}</S.Root>;
};
